import calculateCurrentIndexes from "@/components/Kanban/KPI/calculateIndex";

const sortInitiativesByActuals = (initiative, sortField) => {
  const { currentMonthIndex } = calculateCurrentIndexes();

  const isImpactCheck = sortField === 'actualImpactUpdateCheck';
  const isKPICheck = sortField === 'actualKpiUpdateCheck';

  const dataSources = [];

  if (isImpactCheck && initiative.impact) dataSources.push(...initiative.impact);
  if (isKPICheck && initiative.KPI) dataSources.push(...initiative.KPI);

  const isValid = (v) => v !== null && v !== undefined;

  const lastCompletedMonthIndex = currentMonthIndex - 1;
  const previousMonthsIndices = Array.from({ length: lastCompletedMonthIndex }, (_, i) => i);

  // --- Handle initiatives that are On Hold/Cancelled or low stage first ---
  if (
    ['L0', 'L1', 'L2'].includes(initiative.stage) ||
    ['On Hold', 'Cancelled', 'Rejected'].includes(initiative.weeklyStatus)
  ) {
    return 'No actuals (below L3 or cancelled/on hold)';
  }

  // --- Check for 'No actuals required or no impacts' ---
  const hasNoPlanUntilCurrentMonth = !dataSources.some(d => {
    if (!d || !d.monthlyPlan) return false;
    for (let i = 0; i <= currentMonthIndex; i++) {
      if (isValid(d.monthlyPlan[i])) return true;
    }
    return false;
  });

  const hasNoImpactOrKPI = dataSources.length === 0;
  const hasFinancialImpact = initiative.hasFinancialImpact;

  if (hasNoPlanUntilCurrentMonth || hasNoImpactOrKPI || !hasFinancialImpact) {
    return 'No actuals required or no impacts';
  }

  // --- Aggregate initiative-level statuses ---
  let hasAnyMissingLastCompleted = false;
  let hasAnyMissingPrevious = false;
  let allImpactsFilledLastCompleted = true;
  let allImpactsFilledPrevious = true;

  dataSources.forEach(dataSource => {
    const prevPlanIndices = previousMonthsIndices.filter(index => isValid(dataSource?.monthlyPlan?.[index]));
    const lastCompletedMonthHasPlan = isValid(dataSource?.monthlyPlan?.[lastCompletedMonthIndex]);

    const hasMissingLastCompleted =
      lastCompletedMonthHasPlan && !isValid(dataSource?.monthlyActual?.[lastCompletedMonthIndex]);

    const hasMissingPrevious =
      prevPlanIndices.some(index => !isValid(dataSource?.monthlyActual?.[index]));

    if (hasMissingLastCompleted) {
      hasAnyMissingLastCompleted = true;
      allImpactsFilledLastCompleted = false;
    }

    if (hasMissingPrevious) {
      hasAnyMissingPrevious = true;
      allImpactsFilledPrevious = false;
    }
  });

  // ---- Determine final status (same as filter) ----
  if (hasAnyMissingLastCompleted && hasAnyMissingPrevious) {
    return 'Missing actual in last completed and previous completed months';
  } else if (hasAnyMissingLastCompleted) {
    return 'Missing actual in last completed month';
  } else if (hasAnyMissingPrevious) {
    return 'Missing actual in previous months';
  }

  if (allImpactsFilledLastCompleted && allImpactsFilledPrevious) {
    return 'Filled actual (last completed and previous months required)';
  } else if (allImpactsFilledLastCompleted) {
    return 'Filled actual (last completed month required only)';
  } else if (allImpactsFilledPrevious) {
    return 'Filled actual (previous months required only)';
  }

  return '<not set>';
};

export default sortInitiativesByActuals;
